module.exports = __webpack_public_path__ + "static/media/2a4faf9a.jpg";